import { ButtonDropdown } from '@amzn/awsui-components-console';
import React, { useState } from 'react';
import { CustomSVG } from '../helpers';
import { ActivityInfoWithStatus } from '../activity/LastActivityExecution';
import { ActivityActions } from 'src/constants/hammerstoneConstants';
import { useConditionalEffect } from 'src/commons';
import PipelineBulkActionConfirmModal from './PipelineBulkActionConfirmModal';
import BulkUpdateActivitiesModal from './BulkUpdateActivities';

const dropdownItems = [
	{
		id: ActivityActions.pause,
		text: ActivityActions.pause,
		iconSvg: CustomSVG.Pause,
	},
	{
		id: ActivityActions.resume,
		text: ActivityActions.resume,
		iconSvg: CustomSVG.Resume,
	},
	{
		id: ActivityActions.activate,
		text: ActivityActions.activate,
		iconSvg: CustomSVG.Play,
	},
	{
		id: ActivityActions.delete,
		text: ActivityActions.delete,
		iconName: 'remove' as const,
	},
	{
		id: ActivityActions.update,
		text: ActivityActions.update,
		iconName: 'edit' as const,
	},
] as const;

export default function PipelineBulkActionDropdown(props: {
	selectedActivities: ActivityInfoWithStatus[];
	setSelectedActivities: (activities: ActivityInfoWithStatus[]) => void;
	pipelineName: string;
	isRefreshing: boolean;
	delayRefs: any;
}) {
	const [action, setAction] = useState<string>(''); // bulk action selected

	useConditionalEffect(() => {
		props.setSelectedActivities([]);
	}, [!action]);

	const handleItemClick = ({ detail }: { detail: { id: string } }) => {
		setAction(detail.id);
	};

	return (
		<>
			<ButtonDropdown
				data-testid="bulkEditActivitiesActions"
				items={dropdownItems}
				disabled={!props.selectedActivities?.length}
				onItemClick={handleItemClick}
			>
				Bulk actions
			</ButtonDropdown>
			{action === ActivityActions.update ? (
				<BulkUpdateActivitiesModal
					visible={action === ActivityActions.update}
					onDismiss={() => setAction('')}
					selectedActivities={props.selectedActivities}
					pipelineName={props.pipelineName}
					delayRefs={props.delayRefs}
				/>
			) : (
				<PipelineBulkActionConfirmModal
					pipelineName={props.pipelineName}
					action={action}
					setAction={setAction}
					selectedActivities={props.selectedActivities}
					delayRefs={props.delayRefs}
				/>
			)}
		</>
	);
}
